import throttle from 'lodash.throttle';
import {
  Input,
  Label,
  Icon,
} from 'semantic-ui-react';
import { useQuery, useMutation } from '@apollo/client';
import { useCallback, useState, useEffect } from 'react';

// Local imports
import { useIsAdmin } from '../../hooks/isAdmin';

// --- GraphQL Queries and Mutations ---
import { UPDATE_USER_FIELD } from '../../mutations/UPDATE_USER_FIELDS'
import { GET_PHONE_FIELDS } from './data/GET_PHONE_FIELDS'

interface PhoneProps {
    userId: number,
    inEditMode: boolean,
}

const UserPhoneNumber = ({ userId, inEditMode }: PhoneProps) => {
  const isAdmin = useIsAdmin();
  const [newPhone, setNewPhone] = useState('');

  const { loading, error, data } = useQuery(GET_PHONE_FIELDS, {
    variables: { personId: userId },
    skip: isNaN(userId),
  });

  const [updateUser] = useMutation(UPDATE_USER_FIELD);

  useEffect(() => {
    if (data?.user) {
      setNewPhone(data.user.phone || '');
    }
  }, [data]);

  const CreateUpdater = (field: string) =>
    useCallback(
        async (value: string) => {
          await updateUser({
            variables: {
              userId,
              value,
              field,
            },
          });
        },
      [updateUser, userId]
    );

  const updatePhone = CreateUpdater('phone');

  if (loading || error) {
    return null
  }

  const { phone, canEditPhone } = data.user

  return (
    <>
      {inEditMode && (canEditPhone || isAdmin) ? (
        <Input
          type="text"
          fluid
          style={{minWidth: '180px', height: '20px' }}
          value={newPhone}
          onChange={(e) => {
            setNewPhone(e.target.value);
          }}
          onBlur={() => updatePhone(newPhone)}
        />
      ) : (
        phone && <a href={`tel:${phone}`}>{phone}</a>
      )}
    </>
  );
};

export { UserPhoneNumber };
